import { IOSSocialLogin } from "./IOSSocialLogin";
import AppleButton from "./Buttons/AppleButton";

interface IOSAppleLoginProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
  provider: any;
  isTemp: boolean;
  userID: number;
}

export const IOSAppleLogin = function (props: IOSAppleLoginProps) {
  return (
    <IOSSocialLogin
      {...props}
      providerType="apple"
      isTemp={props.isTemp}
      userID={props.userID}
    >
      <AppleButton onClick={() => {}} />
    </IOSSocialLogin>
  );
};
